/* eslint-disable import/prefer-default-export */
import { generatePath } from 'react-router-dom';

import { API_ADVERTISERS_EDIT_URL } from '../../constants/apiUrls';
import { getRequestJSON } from '../../util/services';

export const get = (apiHost: string, advertiserId: number): Promise<any> =>
  getRequestJSON(apiHost, generatePath(API_ADVERTISERS_EDIT_URL, { id: advertiserId?.toString() }));
